module.exports = __webpack_public_path__ + "static/media/clips-red.870bcd04.svg";